






























































































































import { IAiCopywritingRecord } from "@/common/entity/AiCopywritingRecord";
import { IArticle } from "@/common/entity/Article";
import { PaginationInfo } from "@/common/entity/Pagination";
import { Response } from "@/common/entity/Response";
import { COUNT_NO_LIMIT, User } from "@/common/entity/User";
import { RouterTools } from "@/common/RouterTools";
import { UiTools } from "@/common/UiTools";
import { TopTipsTips } from "@/components/top-tips/TopTips";
import TypeColorText from "@/components/type-color-text/index.vue";
import { AiCopywritingApis } from "@/request/ai-copywriting";
import { ArticleApis } from "@/request/article";
import {
  AiCopywritingInfoOptions,
  RootGetterNames,
  RootMutationNames,
  RootStateNames,
} from "@/vuex-store";
import { Message } from "element-ui";
import { Component, Vue, Watch } from "vue-property-decorator";
import { Getter, Mutation, State } from "vuex-class";

/** 列表名 */
type ListName = "correctList" | "aiCopywritingList";
/** 列表列信息 */
type ColumnInfo<Prop extends string = string> = {
  label: string;
  prop: Prop;
  width?: number;
  showTooltip?: boolean;
  className?: string;
  noActionColumn?: boolean;
  noDelBtn?: boolean;
  noCheckBtn?: boolean;
};
/** 列表数据 */
type ListData = { id: number; canEdit: boolean } & {
  [key: string]: string | number | boolean;
};
/** 列表信息 */
type ListInfo<
  Name extends string = string,
  Data extends ListData = ListData,
> = {
  name: Name;
  label: string;
  data: Data[];
  columnInfos: ColumnInfo<Extract<keyof Data, string>>[];
  pagination: PaginationInfo;
  error?: string;
  refreshing?: boolean;
};
/** 纠错列表中,显示的数据的类型 */
type CorrectListData = {
  /** 纠错记录id */
  id: number;
  /** 纠错文章标题 */
  title: string;
  /** 是否可以编辑 */
  canEdit: boolean;
  /** 纠错记录生成时间，可读时间格式 */
  createdAt: string;
};
/** 智能创作列表中,显示的数据的类型 */
type AiCopywritingListData = {
  /** 智能创作记录id */
  id: number;
  /** 用户生成文案时填写的文案长度 */
  length: number;
  /** 文案描述 */
  desc: string;
  /** 文案风格 */
  style: string;
  /** 生成的文案结果 */
  result: string;
  /** 是否可以编辑 */
  canEdit: true;
  /** 智能创作记录生成时间，可读时间格式 */
  createdAt: string;
};
/** 列表信息map，key为列表名，value为列表信息 */
type ListInfoMap = {
  correctList: ListInfo<"correctList", CorrectListData>;
  aiCopywritingList: ListInfo<"aiCopywritingList", AiCopywritingListData>;
};

/** 默认每页显示条目个数 */
const DEFAULT_PAGINATION: PaginationInfo = {
  pageSize: 10,
  totalSize: 0,
  pageNum: 1,
};

/** 把时间戳转成yyyy-MM-dd hh:mm格式 */
function formatDate(timestampMs: number): string {
  const date = new Date(timestampMs);
  return (
    date.getFullYear() +
    "-" +
    (date.getMonth() + 1 + "-").padStart(3, "0") +
    (date.getDate() + " ").padStart(3, "0") +
    (date.getHours() + ":").padStart(3, "0") +
    (date.getMinutes() + ":").padStart(3, "0") +
    date.getSeconds().toString().padStart(2, "0")
  );
}

@Component({
  components: { TypeColorText },
})
export default class Workbench extends Vue {
  /** 智能创作界面内容状态值 */
  @Mutation(RootMutationNames.updateAiCopywritingInfos)
  readonly updateAiCopywritingInfos!: (infos: AiCopywritingInfoOptions) => void;
  /** 是否已经登录 */
  @Getter(RootGetterNames.isLogined)
  readonly isLogined!: boolean;
  /** 用户名 */
  @Getter(RootGetterNames.userName)
  readonly userName!: string;
  /** AI功能次数剩余 */
  @State(RootStateNames.currUser)
  currUser!: User | null;

  /** AI功能次数剩余显示文本 */
  get aiFuncCountText(): TopTipsTips {
    return this.currUser
      ? this.currUser.correctCount > 0
        ? [
            "剩余AI功能次数：",
            { text: this.currUser.correctCount + "次", colorType: "primary" },
          ]
        : this.currUser.correctCount === COUNT_NO_LIMIT
          ? ["剩余AI功能次数：", { text: "无限", colorType: "primary" }]
          : [
              "试用次数剩余：",
              {
                text: `纠错${this.currUser.correct_test_count}次`,
                colorType: "primary",
              },
              "，",
              {
                text: `智能创作${this.currUser.ai_copywriting_test_count}次`,
                colorType: "primary",
              },
            ]
      : "";
  }

  /** 纠错列表数据 */
  correctDatas: CorrectListData[] = [];
  /** 纠错列表分页信息 */
  correctPagination: PaginationInfo = DEFAULT_PAGINATION;
  /** 纠错列表错误信息 */
  correctError: string = "";
  /** 纠错列表是否正在刷新 */
  correctRefreshing: boolean = false;
  /** 正在删除的纠错记录id */
  correctDeletingId: number[] = [];
  /** 智能创作列表数据 */
  aiCopywritingDatas: AiCopywritingListData[] = [];
  /** 智能创作列表分页信息 */
  aiCopywritingPagination: PaginationInfo = DEFAULT_PAGINATION;
  /** 智能创作列表错误信息 */
  aiCopywritingError: string = "";
  /** 智能创作列表是否正在刷新 */
  aiCopywritingRefreshing: boolean = false;
  /** 正在删除的智能创作记录id */
  aiCopywritingDeletingId: number[] = [];
  /** 列表信息 */
  get listInfos(): ListInfoMap {
    return {
      correctList: {
        name: "correctList",
        label: "检测纠错记录",
        data: this.correctDatas,
        columnInfos: [
          {
            label: "名称",
            prop: "title",
            showTooltip: true,
          },
          { label: "检测时间", prop: "createdAt", width: 200 },
        ],
        pagination: this.correctPagination,
        error: this.correctError,
        refreshing: this.correctRefreshing,
      },
      aiCopywritingList: {
        name: "aiCopywritingList",
        label: "智能创作记录",
        data: this.aiCopywritingDatas,
        columnInfos: [
          {
            label: "描述",
            prop: "desc",
            showTooltip: true,
          },
          { label: "文案风格", prop: "style", width: 100 },
          { label: "创作时间", prop: "createdAt", width: 200 },
        ],
        pagination: this.aiCopywritingPagination,
        error: this.aiCopywritingError,
        refreshing: this.aiCopywritingRefreshing,
      },
    };
  }
  /** 当前选中的列表名 */
  currListName: ListName = "correctList";
  /** 当前选中的列表label */
  get currListLabel(): string {
    return this.listInfos[this.currListName].name;
  }

  /** 登录用户发生变化时刷新所有列表 */
  @Watch("currUser")
  onUserChange(currUser: User | null, oldVal: User | null) {
    if (currUser == oldVal) return;
    if (currUser) {
      this.getCorrectDatas(DEFAULT_PAGINATION);
      this.getAiCopywritingDatas(DEFAULT_PAGINATION);
    } else {
      this.correctDatas = [];
      this.aiCopywritingDatas = [];
    }
  }

  /** 获取纠错列表数据 */
  async getCorrectDatas(info: PaginationInfo) {
    if (!this.isLogined) return;
    if (this.correctRefreshing) return;
    this.correctRefreshing = true;
    try {
      const result = await ArticleApis.list(info.pageNum, info.pageSize, false);
      this.correctPagination = {
        pageNum: result.pageNum,
        pageSize: result.pageSize,
        totalSize: result.totalSize,
      };
      this.correctDatas = result.list.map<CorrectListData>(
        (article: IArticle) => ({
          id: article.id!,
          title: article.title || "",
          canEdit: !article.correct_text,
          createdAt: formatDate(article.created_at! * 1000),
        }),
      );
    } catch (e) {
      console.error(e);
      if (e instanceof Response) this.correctError = "刷新失败：" + e.userMsg;
    }
    this.correctRefreshing = false;
  }
  /** 获取智能创作列表数据 */
  async getAiCopywritingDatas(info: PaginationInfo) {
    if (!this.isLogined) return;
    if (this.aiCopywritingRefreshing) return;
    this.aiCopywritingRefreshing = true;
    try {
      const result = await AiCopywritingApis.list(
        info.pageNum,
        info.pageSize,
        false,
      );
      this.aiCopywritingPagination = {
        pageNum: result.pageNum,
        pageSize: result.pageSize,
        totalSize: result.totalSize,
      };
      this.aiCopywritingDatas = result.list.map(
        (record: IAiCopywritingRecord) => ({
          id: record.id,
          desc: record.desc,
          style: record.style || "",
          createdAt: formatDate(record.created_at),
          length: record.expect_length,
          result: record.result || "",
          canEdit: true,
        }),
      );
    } catch (e) {
      console.error(e);
      if (e instanceof Response)
        this.aiCopywritingError = "刷新失败：" + e.userMsg;
    }
    this.aiCopywritingRefreshing = false;
  }

  /** 点击”查看“记录时调用 */
  onClickCheck(listName: "correctList", data: CorrectListData): void;
  onClickCheck(
    listName: "aiCopywritingList",
    data: AiCopywritingListData,
  ): void;
  onClickCheck(
    listName: ListName,
    data: CorrectListData & AiCopywritingListData,
  ): void {
    switch (listName) {
      case "correctList":
        if (this.correctDeletingId.includes(data.id)) {
          Message.info("此记录正在删除中...");
          return;
        }
        RouterTools.pushTo("acticle", { id: data.id + "" });
        return;
      case "aiCopywritingList":
        this.updateAiCopywritingInfos({
          desc: data.desc,
          length: data.length,
          result: data.result,
          style: data.style,
        });
        RouterTools.pushTo("aiCopywriter");
    }
  }

  /** 点击删除时调用 */
  async onClickDelete(listName: ListName, id: number) {
    switch (listName) {
      case "correctList":
        if (this.correctDeletingId.includes(id)) return;
        const correctIndex = this.correctDeletingId.push(id) - 1;
        await ArticleApis.del(id, false);
        if (this.correctDatas.length === 1)
          await this.getCorrectDatas({
            ...this.correctPagination,
            pageNum: Math.max(this.correctPagination.pageNum - 1, 1),
          });
        else await this.getCorrectDatas(this.correctPagination);
        this.correctDeletingId.splice(correctIndex, 1);
        break;
      case "aiCopywritingList":
        if (this.aiCopywritingDeletingId.includes(id)) return;
        const index = this.aiCopywritingDeletingId.push(id) - 1;
        await AiCopywritingApis.del(id, false);
        if (this.aiCopywritingDatas.length === 1)
          await this.getAiCopywritingDatas({
            ...this.aiCopywritingPagination,
            pageNum: Math.max(this.aiCopywritingPagination.pageNum - 1, 1),
          });
        else await this.getAiCopywritingDatas(this.aiCopywritingPagination);
        this.aiCopywritingDeletingId.splice(index, 1);
        break;
    }
    Message.success("删除成功");
  }

  /** 点击删除错误关闭错误警告时调用 */
  onCloseError(listName: ListName) {
    switch (listName) {
      case "correctList":
        this.correctError = "";
        return;
      case "aiCopywritingList":
        this.aiCopywritingError = "";
    }
  }
  /** 页码发生变化时调用 */
  onPageChange(listName: ListName, pageNum: number) {
    if (!this.isLogined) {
      UiTools.toLogin();
      return;
    }
    switch (listName) {
      case "correctList":
        this.getCorrectDatas({ ...this.correctPagination, pageNum });
        return;
      case "aiCopywritingList":
        this.getAiCopywritingDatas({
          ...this.aiCopywritingPagination,
          pageNum,
        });
        return;
    }
  }
  /** 该记录是否正在删除 */
  isDeleting(listName: ListName, id: number) {
    switch (listName) {
      case "correctList":
        return this.correctDeletingId.includes(id);
      case "aiCopywritingList":
        return this.aiCopywritingDeletingId.includes(id);
    }
  }

  /** 点击“错别字检测”按钮按钮时调用 */
  clickCorrect() {
    RouterTools.pushTo("correct");
  }

  /** 点击“错别字检测范文”按钮时调用 */
  clickExample() {
    RouterTools.pushTo("example");
  }

  /** 点击“智能创作”按钮时调用 */
  clickAiCopywriter() {
    RouterTools.pushTo("aiCopywriter");
  }

  /** 点击“视频提取音频”按钮时调用 */
  clickVideo2Audio() {
    RouterTools.pushTo("video2Audio");
  }

  /** 点击“音/视频提取文案”按钮时调用 */
  clickSpeechRecognition() {
    RouterTools.pushTo("speechRecognition");
  }

  /** 挂载完成时回调 */
  mounted() {
    this.getCorrectDatas(this.correctPagination);
    this.getAiCopywritingDatas(this.aiCopywritingPagination);
  }
}
